/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { OrchestrationType } from 'src/clu/core/stores/CluIntentStore';
import { AppStore } from 'src/core/stores/app/AppStore';
import { RootStore } from 'src/core/stores/RootStore';
import { Dispatcher } from 'src/core/types/dispatcher';
import { GlobalHandlerGroup } from 'src/core/types/GlobalHandlerGroup';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';

export type CluConnectedIntentsDto = {
    projectId: string;
    intentName: string;
    versionId?: string;
    serviceType: OrchestrationType;
};

export const orchestrationTypeDropdownOptions: IDropdownOption[] = [
    { key: 'Luis', text: 'LUIS' },
    { key: 'QuestionAnswering', text: 'Question Answering' },
    { key: 'Conversation', text: 'Conversational Language Understanding' }
];

export const getConnectionReadableName = (connectionCode: OrchestrationType) => {
    switch (connectionCode) {
        case 'QuestionAnswering':
            return 'Question answering';
        case 'Luis':
            return 'LUIS';
        case 'Conversation':
            return 'Conversational Language';
        default:
    }
};

export const getAppStoresByOrchestrationType = (
    orchestrationType: OrchestrationType,
    rootStore: RootStore
): ResourceStoreHouse<AppStore> => {
    switch (orchestrationType) {
        case 'Conversation':
            return rootStore.cluProjectStoreHouse;
        case 'Luis':
            return rootStore.luisAppStoreHouse;
        case 'QuestionAnswering':
            return rootStore.qnaProjectStoreHouse;
        default:
            return undefined;
    }
};

export const dispatchAppStoresByOrchestrationType = (service: OrchestrationType, dispatcher: Dispatcher<GlobalHandlerGroup>) => {
    switch (service) {
        case 'Luis':
            dispatcher.dispatch('loadLuisApps', { context: { forceRefresh: true } });
            break;
        case 'Conversation':
            dispatcher.dispatch('loadCluProjects');
            break;
        case 'QuestionAnswering':
            dispatcher.dispatch('getQnaMakerProjects', { context: { forceRefresh: true } });
            break;
        default:
    }
};
